export default class HoverCaption {
  constructor () {
    // Only initialize on non-touch devices
    if ('ontouchstart' in window) return
    
    this.figures = document.querySelectorAll('[data-captiononhover="true"]')
    this.figures.forEach(figure => {
      const caption = figure.querySelector('figcaption, [data-caption]')
      if (!caption) return
      
      // Hide caption by default
      caption.style.cssText = `
        position: fixed;
        pointer-events: none;
        opacity: 0;
        transform: translate(10px, 10px);
        transition: opacity 0.2s;
        z-index: 1000;
        width: 450px;
        max-width: 90vw;
        bottom: unset;
      `
      
      // Support both img and video elements
      const media = figure.querySelector('img, video')
      if (!media) return
      
      media.addEventListener('mousemove', (e) => {
        caption.style.opacity = '1'
        caption.style.left = `${e.clientX}px`
        caption.style.top = `${e.clientY}px`
      })
      
      media.addEventListener('mouseleave', () => {
        caption.style.opacity = '0'
      })
    })
  }
} 